import { render } from "./scoreCard.vue?vue&type=template&id=67861fda&scoped=true"
import script from "./scoreCard.vue?vue&type=script&lang=js"
export * from "./scoreCard.vue?vue&type=script&lang=js"

import "./scoreCard.vue?vue&type=style&index=0&id=67861fda&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67861fda"]])

export default __exports__